module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_EL-f1890922c23afcaa3f755bdb9f62722b.svg";